import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { red } from "@mui/material/colors";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, ListItem } from "@mui/material";
import { StateProps } from "../state";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

export function RecipeCardModal(props: StateProps) {
  const [expanded, setExpanded] = React.useState(false);

  const { state, setState } = props;

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: 24,
        display: "flex",
        flexDirection: "column",
        border: "1px solid red",
      }}
    >
      <Card
        sx={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          width: "95%",
        }}
      >
        <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
              {state.selectedRecipe?.name.slice(0, 1).toUpperCase()}
            </Avatar>
          }
          title={`${state.selectedRecipe?.name}`}
        />
        <CardContent>
          <Box
            sx={{
              overflowY: "scroll",
              maxHeight: "25em",
            }}
          >
            {state.selectedRecipe?.instructions.map((instruction) => {
              return (
                <>
                  <Box
                    sx={{
                      overflowY: "scroll",
                      maxHeight: "10.5em",
                    }}
                  >
                    {instruction.ingredients?.map((ingredient) => {
                      return (
                        <ListItem sx={{ color: "text.secondary" }}>
                          {ingredient.name}
                        </ListItem>
                      );
                    })}
                  </Box>

                  <Box
                    sx={{
                      overflowY: "scroll",
                      maxHeight: "10.75em",
                    }}
                  >
                    {instruction.instructions.map((i, idx) => {
                      return (
                        <ListItem sx={{ color: "text.secondary" }}>{`${
                          idx + 1
                        }: ${i}`}</ListItem>
                      );
                    })}
                  </Box>
                </>
              );
            })}
          </Box>
        </CardContent>
        <CardActions disableSpacing>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
            disabled={true}
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>
      </Card>
    </Box>
  );
}
